const ALLOWED_MULTIPLE_CODES_COUNTRIES = ["US", "CA"];

export const shouldShowInput = (country: string, codesCount: number) => {
    const allowMultiplePromoCodes = ALLOWED_MULTIPLE_CODES_COUNTRIES.includes(country);

    return codesCount < 1 || allowMultiplePromoCodes;
};
